export const iotDevicesTypes = {
  GET_IOT_DEVICES: 'GET_IOT_DEVICES',
  GET_IOT_DEVICE: 'GET_IOT_DEVICE',
  CREATE_IOT_DEVICE: 'CREATE_IOT_DEVICE',
  MOD_IOT_DEVICE: 'MOD_IOT_DEVICE',
  SET_IOT_DEVICE_SELECTED: 'SET_IOT_DEVICE_SELECTED',
  RESET_IOT_DEVICE_SELECTED: 'RESET_IOT_DEVICE_SELECTED',
  ADD_IOT_DEVICE_MODE: 'ADD_IOT_DEVICE_MODE',
  EDIT_IOT_DEVICE_MODE: 'EDIT_IOT_DEVICE_MODE',
  GET_ASSIGN_HISTORY: 'GET_ASSIGN_HISTORY',
  GET_IOT_DEVICES_BY_ACCOUNT: 'GET_IOT_DEVICES_BY_ACCOUNT',
  CLEAR_ACCOUNT_IOT_DEVICES: 'CLEAR_ACCOUNT_IOT_DEVICES',
  SET_IOT_DEVICES_FILTERS: 'SET_IOT_DEVICES_FILTERS',
  RESTORE_INITIAL: 'RESTORE_INITIAL_IOT_DEVICES',
};
